"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LiveTickerList = _interopRequireDefault(require("./LiveTickerList.scss"));

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var LiveTickerList = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LiveTickerList, _React$Component);

  var _super = _createSuper(LiveTickerList);

  function LiveTickerList(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, LiveTickerList);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToTop", function () {
      var div = document.getElementById(_this.divId);
      div.scrollTop = 0;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDivScrolled", function () {
      var div = document.getElementById(_this.divId);
      console.log("div scrolled to position ".concat(div.scrollTop, " / scrollHeight: ").concat(div.scrollHeight));

      if (div.scrollTop < 50 && _this.state.showNewMessageInfo) {
        _this.setState({
          showNewMessageInfo: false
        });
      }
    });
    _this.state = {
      showNewMessageInfo: false
    };
    _this.divId = _StringHelper["default"].createShortId();
    return _this;
  }

  (0, _createClass2["default"])(LiveTickerList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var div = document.getElementById(this.divId);

      if (div.scrollTop > 50 && prevProps.children && this.props.children && prevProps.children.length < this.props.children.length) {
        this.setState({
          showNewMessageInfo: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react["default"].createElement("div", {
        id: this.divId,
        className: _LiveTickerList["default"].livetickerList,
        onScroll: this.onDivScrolled
      }, this.props.children, this.state.showNewMessageInfo && /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          _this2.scrollToTop();
        },
        style: {
          position: 'absolute',
          backgroundColor: 'black',
          color: 'white',
          padding: '5px',
          left: '50%',
          bottom: '10px',
          transform: 'translateX(-50%)'
        }
      }, "Neue Nachrichten verf\xFCgbar"));
    }
  }]);
  return LiveTickerList;
}(_react["default"].Component);

LiveTickerList.propTypes = {
  children: _propTypes["default"].node
};
var _default = LiveTickerList;
exports["default"] = _default;